// import { MainPageBreadcrumbLayout } from "../acadia/MainPage";
import { useState } from "react";
import CheckListsMain from "./checkList/CheckList.mobile";
import ActionsMainPage from "./components/actionsMainPage/actionsMainPage.mobile";
import Audits5sMainPage from "./components/audits5sMainPage/audits5sMainPage.mobile";
import List5WayMainPage from "./components/list5WayMainPage/list5WayMainPage.mobile";
import ListIncMainPage from "./components/listIncMainPage/listIncMainPage.mobile";
import { FiveWhyType } from 'src/api/config/systemSwitch';
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "./../../../modules/users/selector";

const MainPageMobile = () => {
  const [openComponentId, setOpenComponentId] = useState<string>('checklist-main');
  const currentUser = useAppSelector(selectCurrentUser);

  return (

    <div className="w-full">
      <CheckListsMain email={currentUser.email} jobTitleStr={currentUser.jobTitleStr || currentUser.jobTitle} />
      <Audits5sMainPage
        id="audits-5s-main-page"
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
      />
      <ActionsMainPage
        id="actions-main-page"
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
        />
      <List5WayMainPage
        // type="5Way"
        type={FiveWhyType}
        user="AuthorEmail"
        id="5way-author-email"
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
      />
      <List5WayMainPage
        // type="5Way"
        type={FiveWhyType}
        user="Editors"
        id="5way-editors"
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
      />
      {/* <List5WayMainPage
        type="DeviationReport"
        user="AuthorEmail"
        id="deviationreport-author-email"
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
      />
      <List5WayMainPage
        type="DeviationReport"
        user="Editors"
        id="deviationreport-editors"
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
      /> */}
      <ListIncMainPage
        id="discrepancy-main-page"
        type={`"IncidentOption":"Несоответствие"`}
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
      />
      <ListIncMainPage
        id="incident-main-page"
        type={`"IncidentOption":"Инцидент"`}
        openComponentId={openComponentId}
        setOpenComponentId={setOpenComponentId}
      />
    </div>

  );
};

export default MainPageMobile;
